module.exports = __webpack_public_path__ + "static/media/blueTick.9ec6f8a3.svg";